/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

// StartCustomCode - Judge.me "Show more" reviews threshold override (product pages only)
// ----------------------------------------------------------------------------------------
// Goal: Judge.me's v3 widget (`jdgm-widget-revamp`) renders a paginated set of reviews
// into a masonry grid. For products with enough reviews to need pagination, Judge shows
// its own "Show more" button (`.jdgm-masonry-grid__btn`) that loads more reviews per
// click. For smaller-review products, Judge renders all reviews up-front and shows no
// button. We want a "Show more reviews" button to appear with a lowered threshold of
// 6 on desktop and 2 on mobile, but ONLY when Judge isn't going to handle the widget
// itself — otherwise we'd compete with Judge's own button or appear once Judge has
// finished paginating.
//
// Behaviour:
//   - Judge ever renders its own button on this widget → we stand down PERMANENTLY for
//     the lifetime of this page view (covers the case where Judge paginates: shows a
//     button, click loads more, shows button again, click loads more, then stops — at
//     which point we must NOT step in with our own button).
//   - Judge never shows its button AND review count > our threshold → inject our own
//     button (visually styled to match Judge's button via the same `.jdgm-masonry-grid__btn`
//     class, wrapped in a matching `.jdgm-masonry-grid__footer` so it inherits Judge's
//     look-and-feel).
//   - Review count ≤ threshold → no button needed.
//
// Verified DOM (Judge.me v3, rendered by Vue.js after `review_widget.js` loads):
//   #judgeme_product_reviews                                  — stable server-rendered id
//     .jm-review-widget__body
//       .jdgm-masonry-grid
//         .jdgm-masonry-grid__container
//           .jdgm-masonry-grid__masonry-item                  — one wrapper per review
//             .jdgm-review-card
//         .jdgm-masonry-grid__footer                          — Judge's footer (when paginating)
//           button.jdgm-masonry-grid__btn                     — Judge's own "Show more"
//
// How it works:
//   1. Bail out unless we're on a product page (`body.template-product`).
//   2. Inject a `<style>` tag with `:nth-child(n+N)` rules that hide masonry items
//      beyond the threshold — but ONLY when the widget has the `jdgm-custom-collapse`
//      class AND not the `jdgm-custom-expanded` class. CSS-based hiding survives Vue's
//      re-renders.
//   3. On every MutationObserver / poll tick:
//        a. If Judge's `.jdgm-masonry-grid__btn` is currently present → mark widget as
//           `jdgm-judge-handled` (permanent flag) and stand down.
//        b. If widget already has `jdgm-judge-handled` → stand down forever — even if
//           Judge has now removed its own button after paginating to the end.
//        c. Else if review count > current threshold → apply collapse class (CSS hides
//           extras) and inject our button (only once).
//        d. Else → stand down (no button needed).
//   4. Clicking our button adds `jdgm-custom-expanded` — CSS rules stop matching, all
//      hidden cards appear, button removes itself.
//   5. Resize (debounced) re-evaluates so a viewport that crosses the mobile/desktop
//      breakpoint gets the right count.
(function() {
  if (!document.body.classList.contains('template-product')) return;

  var DESKTOP_THRESHOLD = 6;
  var MOBILE_THRESHOLD  = 2;
  var MOBILE_BREAKPOINT = 768;
  var WIDGET_ID         = 'judgeme_product_reviews';
  var BTN_CLASS         = 'jdgm-custom-show-more';
  var EXPANDED_CLASS    = 'jdgm-custom-expanded';
  var COLLAPSE_CLASS    = 'jdgm-custom-collapse';
  var JUDGE_HANDLED_CLASS = 'jdgm-judge-handled';
  var STYLE_ID          = 'jdgm-custom-show-more-style';
  var ITEM_SELECTOR     = '.jdgm-masonry-grid__container > .jdgm-masonry-grid__masonry-item';
  // Exclude our own button — it carries `.jdgm-masonry-grid__btn` for styling, so without
  // this `:not()` we'd mistake our button for Judge's and immediately stand down.
  var NATIVE_BTN_SELECTOR = '.jdgm-masonry-grid__btn:not(.' + 'jdgm-custom-show-more' + ')';

  var BTN_LABEL = 'Show more reviews';
  var FADE_HEIGHT_PX = 80; // depth of the gradient overlay above the button

  // CSS only applies when `jdgm-custom-collapse` is set AND `jdgm-custom-expanded` is not.
  // Judge-handled widgets never get the collapse class, so they're untouched.
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var prefix = '#' + WIDGET_ID + '.' + COLLAPSE_CLASS + ':not(.' + EXPANDED_CLASS + ') ';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '/* Mobile: keep first ' + MOBILE_THRESHOLD + ' items, hide the rest. */',
      '@media (max-width: ' + (MOBILE_BREAKPOINT - 1) + 'px) {',
      '  ' + prefix + ITEM_SELECTOR + ':nth-child(n+' + (MOBILE_THRESHOLD + 1) + ') {',
      '    display: none !important;',
      '  }',
      '}',
      '/* Desktop: keep first ' + DESKTOP_THRESHOLD + ' items, hide the rest. */',
      '@media (min-width: ' + MOBILE_BREAKPOINT + 'px) {',
      '  ' + prefix + ITEM_SELECTOR + ':nth-child(n+' + (DESKTOP_THRESHOLD + 1) + ') {',
      '    display: none !important;',
      '  }',
      '}',
      // Footer wraps the button + the fade overlay. position:relative anchors the
      // absolutely-positioned peek; flex centers the button to match Judge's footer.
      '#' + WIDGET_ID + ' .' + BTN_CLASS + '-footer {',
      '  position: relative;',
      '  display: flex;',
      '  justify-content: center;',
      '}',
      '#' + WIDGET_ID + ' .' + BTN_CLASS + ' svg {',
      '  margin-left: 4px;',
      '}',
      // Peek overlay sits ABOVE the button (bottom:100%) and extends upward, fading
      // the bottom of the last visible review into the page background. Mirrors Judge's
      // .jdgm-masonry-grid__peek + .jdgm-masonry-grid__fade structure. pointer-events
      // none so the fade never intercepts clicks meant for the review card.
      '#' + WIDGET_ID + ' .' + BTN_CLASS + '-peek {',
      '  position: absolute;',
      '  bottom: 100%;',
      '  left: 0;',
      '  right: 0;',
      '  height: ' + FADE_HEIGHT_PX + 'px;',
      '  pointer-events: none;',
      '}',
      '#' + WIDGET_ID + ' .' + BTN_CLASS + '-fade {',
      '  width: 100%;',
      '  height: 100%;',
      '  background: linear-gradient(rgba(255,255,255,0) 0%, rgb(255,255,255) 100%);',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function getThreshold() {
    return window.innerWidth < MOBILE_BREAKPOINT ? MOBILE_THRESHOLD : DESKTOP_THRESHOLD;
  }

  // Remove our footer wrapper + collapse class + container-height override.
  // Used when no custom button is needed (review count under threshold or Judge handles it).
  // Only clear container.style.height if WE previously set it (signalled by the collapse
  // class). For Judge-handled widgets we never engaged with, masonry's own inline height
  // is the only thing keeping the container open — wiping it would collapse to 0px and
  // (with grid overflow:hidden) hide every review.
  function standDown(widget) {
    var weEngaged = widget.classList.contains(COLLAPSE_CLASS);
    widget.classList.remove(COLLAPSE_CLASS);
    if (weEngaged) {
      var container = widget.querySelector('.jdgm-masonry-grid__container');
      if (container) container.style.height = '';
    }
    var existingFooter = widget.querySelector('.' + BTN_CLASS + '-footer');
    if (existingFooter) existingFooter.remove();
  }

  // Build a footer with: a fade overlay (peek/fade) that sits above the button to soften
  // the bottom of the last visible review, plus the button itself. Visually mirrors
  // Judge's native --peeking footer.
  function buildButton(onClick) {
    var footer = document.createElement('div');
    footer.className = 'jdgm-masonry-grid__footer ' + BTN_CLASS + '-footer';

    var peek = document.createElement('div');
    peek.className = BTN_CLASS + '-peek';
    peek.setAttribute('aria-hidden', 'true');
    var fade = document.createElement('div');
    fade.className = BTN_CLASS + '-fade';
    peek.appendChild(fade);
    footer.appendChild(peek);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jdgm-masonry-grid__btn ' + BTN_CLASS;
    // Match Judge's button content: text followed by a chevron-down SVG icon. Path data
    // copied verbatim from Judge's own button so the icon is identical.
    btn.innerHTML = BTN_LABEL + ' <svg width="16" height="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.06 5.53027L8 8.58361L4.94 5.53027L4 6.47027L8 10.4703L12 6.47027L11.06 5.53027Z"></path></svg>';
    btn.addEventListener('click', onClick);
    footer.appendChild(btn);
    return footer;
  }

  // Masonry items are position:absolute and the container's height is fixed by the
  // masonry library to fit ALL items. When we hide items via display:none, the container
  // keeps its original height — leaving a large empty gap before our button. Recompute
  // height to match the bottom of the last currently-visible item.
  function syncContainerHeight(widget) {
    var container = widget.querySelector('.jdgm-masonry-grid__container');
    if (!container) return;
    var items = widget.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) return;
    var containerTop = container.getBoundingClientRect().top;
    var maxBottom = 0;
    for (var i = 0; i < items.length; i++) {
      if (getComputedStyle(items[i]).display === 'none') continue;
      var b = items[i].getBoundingClientRect().bottom;
      if (b > maxBottom) maxBottom = b;
    }
    if (maxBottom > 0) {
      container.style.height = Math.ceil(maxBottom - containerTop) + 'px';
    }
  }

  // Rewrite the text inside Judge's native "Show more" button to match our copy. Vue may
  // re-render and reset it; we run on every observer tick, so any reset is corrected on
  // the next pass. characterData mutations don't fire our childList observer, so this
  // doesn't loop.
  function retextJudgeBtn(widget) {
    var nativeBtn = widget.querySelector(NATIVE_BTN_SELECTOR);
    if (!nativeBtn) return;
    var children = nativeBtn.childNodes;
    for (var i = 0; i < children.length; i++) {
      var node = children[i];
      if (node.nodeType !== 3) continue; // 3 = TEXT_NODE
      var v = node.nodeValue;
      if (v.indexOf('Show more') !== -1 && v.indexOf(BTN_LABEL) === -1) {
        node.nodeValue = v.replace('Show more', BTN_LABEL);
      }
    }
  }

  function processWidget() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    // User already clicked our button — leave the widget fully expanded
    if (widget.classList.contains(EXPANDED_CLASS)) return;

    // If Judge's button has ever been seen on this widget, stay out of its way for the
    // rest of the page lifetime — Judge may paginate (button → click → button → click →
    // gone). We must not step in after Judge has finished paginating.
    if (widget.querySelector(NATIVE_BTN_SELECTOR)) {
      widget.classList.add(JUDGE_HANDLED_CLASS);
    }
    if (widget.classList.contains(JUDGE_HANDLED_CLASS)) {
      standDown(widget);
      retextJudgeBtn(widget); // also rename Judge's button if it's currently rendered
      return;
    }

    var items = widget.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) return;

    var threshold = getThreshold();

    // No button needed
    if (items.length <= threshold) {
      standDown(widget);
      return;
    }

    // Step in — apply CSS hiding via the collapse class
    widget.classList.add(COLLAPSE_CLASS);

    if (!widget.querySelector('.' + BTN_CLASS)) {
      var grid = widget.querySelector('.jdgm-masonry-grid');
      if (!grid) return;
      // Place our footer/button INSIDE the .jdgm-masonry-grid (same position Judge uses)
      // so it inherits any container-scoped styling.
      var footer = buildButton(function() {
        widget.classList.add(EXPANDED_CLASS);
        footer.remove();
        // Reset container height so all newly-revealed items have room to render.
        var container = widget.querySelector('.jdgm-masonry-grid__container');
        if (container) container.style.height = '';
        // After a tick, recompute height to fit ALL items (now visible) — the original
        // masonry-set height may have been replaced by ours, and the inline style reset
        // alone leaves the container at "auto" which collapses around absolute children.
        setTimeout(function() { syncContainerHeight(widget); }, 0);
      });
      grid.appendChild(footer);
    }

    // Always close the masonry-induced gap on every pass so we stay tight even after
    // the layout shifts (Vue re-render, font load, image decode, etc.).
    syncContainerHeight(widget);
  }

  injectStyle();

  var observer = new MutationObserver(processWidget);
  observer.observe(document.body, { childList: true, subtree: true });

  var pollCount = 0;
  var pollTimer = setInterval(function() {
    processWidget();
    if (++pollCount >= 40) clearInterval(pollTimer);
  }, 500);

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(processWidget, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processWidget);
  } else {
    processWidget();
  }
})();
// EndCustomCode